<div class="container gap-3 d-grid">
    <!-- <div class="row searchbykeyword">
        <div class="searchLabel row">
            <div class="col-lg-1 col-md-1 col-sm-2 col-xs-2">
                <img class="searchicon" src="assets/images/search.svg" alt="Unable to load image"/>
            </div>
            <div class="col-lg-10 col-md-9 col-sm-7 col-xs-7">
                <p class="searchLabelText d-lg-block d-md-none d-sm-none d-xs-none d-none">Search by student name,
                    Member ID</p>
                <p class="searchLabelText2 d-md-block d-sm-block d-lg-none d-xs-block">Search by student name,
                    Member ID</p>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-3 col-xs-3">
                <button mat-button class="downbutton" (click)="ToggleSearchBox()">
                    <img class="downIcon" src="assets/images/down.svg" alt="Unable to load image"/>
                </button>
            </div>
        </div>
    </div> -->
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 gap-3 searchBox">
            <form #searchBox="ngForm">
                <div class="row fields">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <label>Student First Name</label>
                        <input type="text" name="firstName" placeholder="Enter Student First Name"
                            [(ngModel)]="searchRequest.firstName" />
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <label>Student Last Name</label>
                        <input type="text" name="lastName" placeholder="Enter Student Last Name"
                            [(ngModel)]="searchRequest.lastName" />
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <label>Date Of Birth</label>
                        <input type="date" name="dob" [(ngModel)]="searchRequest.dateOfBirth" />
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <label>Member ID Number</label>
                        <input type="text" name="ssn" placeholder="Member ID" [(ngModel)]="searchRequest.ssn" />
                    </div>
                </div>
                <div class="row error" *ngIf="error!=''">
                    {{error}}
                </div>
                <div class="row searchButtons">
                    <div class="col-lg-8 .d-none .d-lg-block"></div>
                    <div class="col-lg-2 col-md-6 col-sm-6"><button type="button" class="clearButton" (click)="reset()">Clear
                            Filter</button></div>
                    <div class="col-lg-2 col-md-6 col-sm-6"><button class="searchBoxButton" (click)="Search()"
                            type="submit">Search</button></div>
                </div>
            </form>
        </div>
    </div>
    <!-- <div class="row" *ngIf="viewSearch">
       <div class="col-lg-3 col-md-6 col-sm-6">
        <p>Student First Name:{{searchRequest.firstName}} </p>
        <p>Date Of Birth:{{searchRequest.dateOfBirth}}</p>
       </div>
       <div class="col-lg-3 col-md-6 col-sm-6">

        <p>Student Last Name:{{searchRequest.lastName}}</p>
        <p>Member ID:{{searchRequest.ssn}}</p>
       </div>
    </div> -->

    <div
      class="row"
      *ngIf="isLoadingStudents">
      <div class="col text-center">
        <div class="spinner-border text-secondary my-3" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>

    <div
      *ngIf="dataSource.filteredData.length==0 && showMsg && isSearch && !isLoadingStudents"
      class="noResult text-center">
      <h5 class="text-secondary">No Students Found</h5>
    </div>

    <div
      class="row"
      *ngIf="isSearch"
      [class.d-none]="isLoadingStudents">
        <div class="row tableTitleRow" *ngIf="dataSource.filteredData.length>0">
            <div class="col-lg-10 col-md-8 col-sm-7 table-title">
                Search Results
            </div>
        </div>
        <div class="row">
            <div class="">
                <table mat-table [dataSource]="dataSource" *ngIf="dataSource.filteredData.length>0">
                    <!-- <ng-container matColumnDef="memberid"  >
                        <th mat-header-cell *matHeaderCellDef class="tableHeader"> Student ID </th>
                        <td mat-cell *matCellDef="let element"> {{element.ssn}} </td>
                    </ng-container> -->
                    <ng-container matColumnDef="firstName">
                        <th mat-header-cell *matHeaderCellDef class="tableHeader"> First Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="lastName">
                        <th mat-header-cell *matHeaderCellDef class="tableHeader"> Last Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="dateofBirth">
                        <th mat-header-cell *matHeaderCellDef class="tableHeader"> Date Of Birth </th>
                        <td mat-cell *matCellDef="let element" style="width: 105px;"> {{element.dob | date:'yyyy-MM-dd' }} </td>
                    </ng-container>
                    <ng-container matColumnDef="location">
                        <th mat-header-cell *matHeaderCellDef class="tableHeader"> Location </th>
                        <td mat-cell *matCellDef="let element"> {{element.campusName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="memberid"  >
                        <th mat-header-cell *matHeaderCellDef class="tableHeader"> Member ID </th>
                        <td mat-cell *matCellDef="let element"> {{element.ssn}} </td>
                    </ng-container>
                    <ng-container matColumnDef="rosterStatus">
                        <th mat-header-cell *matHeaderCellDef class="tableHeader"> Roster Status </th>
                        <td mat-cell *matCellDef="let element" class="px-0" style="width: 115px;"> <span [ngClass]="element.cC_TransactionID!=null?(element.cC_TransactionID.includes('ROSTER') ? 'rosterAdded' : 'rosterNotAdded'):'rosterNotAdded'"> {{ element.cC_TransactionID?(element.cC_TransactionID.includes('ROSTER') ? 'Added' : 'Not Added'):'Not Added'}} </span></td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="tableHeader"> Action </th>
                        <td mat-cell *matCellDef="let element" style="width: 70px;" class="text-center">
                            <button mat-icon-button class="viewButton" (click)="OpenStudentDetailsPopup(element)">
                                <img src="./assets/images/eye.svg">
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

                <!--Draft paginator-->
                <div
                  class="row d-flex paginator"
                  [class.d-none]="dataSource.filteredData.length == 0">
                    <div class="col-lg-6 col-sm-6 col-md-6">
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4">
                            <mat-form-field class="go-to-select">
                                <mat-label >Go To Page:</mat-label>
                                <mat-select  [(ngModel)]="goTo" (selectionChange)="goToChange()">
                                    <mat-option *ngFor="let pageNumber of pageNumbers" [value]="pageNumber">{{pageNumber}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                           </div>
                           <div class="col-lg-4 col-md-4 col-sm-4">

                        </div>
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <span> Page {{selectedPageNumber}} of {{currenttotalPages}}</span>
                            </div>
                        </div>



                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <mat-paginator  [pageIndex]="pageIndex" #searchByKeywordPaginator
                        [length]="dataSource.filteredData.length" [pageSize]="10"
                        (page)="onPaginateChange($event)"></mat-paginator>

                    <!-- <mat-paginator #paginator [length]="dataSource.filteredData.length" [pageSize]="10"
                    (page)="onPaginateChange($event)"  aria-label="Select page">
                </mat-paginator> -->
                 </div>



                </div>
            </div>

        </div>
    </div>
</div>
